import { apiFetch } from "./apiClient";
import { mockApi } from "./mockData";

/**
 * GET /api/legends/{product_type}/
 * Response: { title, stops: [{min, max, color}], vmin, vmax, unit, source }
 */
export async function fetchLegend(productType) {
  return apiFetch(`/api/legends/${encodeURIComponent(productType)}/`, {
    method: "GET",
    mockHandler: () => mockApi.getLegend(productType),
  });
}
